import Vue from 'vue';
import './operational-dashboard';

Vue.component('dashboard-index-main', () =>
    import(/* webpackChunkName: 'dashboard-index' */ './dashboard-index.vue'),
);

Vue.component('dashboard', () =>
    import(/* webpackChunkName: 'dashboard' */ './dashboard.vue'),
);

Vue.component('dashboard-report', () =>
    import(/* webpackChunkName: 'dashboard' */ './dashboard-report.vue'),
);

Vue.component('dashboard-target-sales', () =>
    import(/* webpackChunkName: 'dashboard' */ './dashboard-target-sales.vue'),
);
